import * as Yup from 'yup';

export const MedicationsRowSchema = Yup.object().shape({
  id: Yup.number().optional(),
  medication_name: Yup.string().trim().required(),
  dosage: Yup.string().trim().required(),
  physician: Yup.string().trim().required(),
  reason: Yup.string().trim().required(),
  date_start: Yup.string().trim().required(),
});
